import type { ComponentProps, PropsWithChildren } from 'react';
import type React from 'react';

import { cn } from '@change/ds-utils';

type Variant = 'error' | 'success' | 'purple';

type Props = Readonly<{
	big?: boolean;
	/**
	 * default: error (yellow)
	 */
	variant?: Variant;
}>;

// Colour literals preserved from the previous theme-ui styling.
const VARIANT_CLASSES: Record<Variant, string> = {
	error:
		'border-b border-solid border-[#ffe9aa] bg-[#fff9df] text-[#b48629] [&_a]:text-[#b48629] [&_a:hover]:text-[#dab65d] [&_a:focus]:text-[#dab65d]',
	success: 'border-b border-solid border-[#bbd6b2] bg-[#e2eee0] text-[#497143] [&_a]:text-[#63985a]',
	purple: 'border-b border-solid border-[#ffe9aa] bg-[#3E1B63] text-white',
};

export const BannerWrapper: React.FC<PropsWithChildren<Props> & Omit<ComponentProps<'div'>, 'variant'>> = ({
	children,
	big,
	variant = 'error',
	className,
	...rest
}) => {
	return (
		<div role="alert" data-nosnippet className={cn(VARIANT_CLASSES[variant], className)} {...rest}>
			{/* "small" container: full-width on mobile, 740px at md, 960px at lg (max 960px) */}
			<div
				className={cn(
					'mx-auto max-w-[960px] px-2 md:w-[740px] lg:w-[960px] [&_a]:font-bold [&_a]:underline',
					big ? 'py-2 text-base leading-6' : 'py-0.5 text-sm leading-5',
				)}
			>
				{children}
			</div>
		</div>
	);
};
